/**************************************************
 * Nombre:       Detalle_Producto_Img_Caracteristicas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Detalle_Producto_Img_Caracteristicas_Caracteristicas
    from "./Detalle_Producto_Img_Caracteristicas_Caracteristicas";
import Detalle_Producto_Img_Caracteristicas_Img from "./Detalle_Producto_Img_Caracteristicas_Img";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {useTallaDesplegable} from "../../../Modulo_eComerce/Hooks/useTallaDesplegable";
import Home_Suscripcion from "./Home_Suscripcion";
import Detalle_Producto_Match from "./Detalle_Producto_Match";


const Detalle_Producto_Img_Caracteristicas = ({producto = {}}) => {
    const {sCell} = useResponsive()
    const {Tallas, seleccionada} = useTallaDesplegable({variaciones: producto.variaciones ? producto.variaciones : []})

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}

        >

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: sCell ? 0 : 6}}
                spacing={8}
            >

                <Grid container size={{xs: 12, sm: 6, md: 7}} sx={{justifyContent: 'center'}}>
                    <Detalle_Producto_Img_Caracteristicas_Img producto={producto} Tallas={Tallas}
                                                              seleccionada={seleccionada}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 6, md: 5}}
                      sx={{position: "sticky", top: 20, px: sCell ? 3 : 0}}
                >
                    <Detalle_Producto_Img_Caracteristicas_Caracteristicas producto={producto} />
                </Grid>




            </Grid>


        </Grid>
    )

}
export default Detalle_Producto_Img_Caracteristicas